// @flow
import * as React from 'react'
import { connect } from 'react-redux'

import { routerActions } from '@modules/router'
import styles from './styles'

type Props = {
  to: string,
  navigateTo: Function,
  children: React.Node,
  style: Object
}

const mapDispatchToProps = (dispatch: Function) => ({
  navigateTo: (to: string) => dispatch(routerActions.navigateTo(to))
})

const Link = (props: Props) => {
  return (
    // eslint-disable-next-line
    <a role='button' onClick={() => props.navigateTo(props.to)} style={styles.link(props.style)}>
      {props.children}
    </a>
  )
}

export default connect(null, mapDispatchToProps)(Link)
